import { AxiosResponse } from "axios"

const handleQueryResult = async <T>(request: Promise<AxiosResponse<T>>) => {
	try {
		const result = await request
		return { data: result.data }
	} catch (error: unknown) {
		return { error }
	}
}

export default handleQueryResult
